"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useState } from "react";
export default function WhoIAm() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: whyRef,
    isVisible: whyVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const [imageHovered, setImageHovered] = useState(false);
  return <section ref={ref} className="bg-background py-16 px-6 md:px-12 lg:px-24" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(20px)",
    transition: "opacity 200ms ease-out, transform 200ms ease-out"
  }}>
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {}
          <div className="relative" style={{
          transform: isVisible ? imageHovered ? "translateY(-4px) scale(1.02)" : "translateY(0) scale(1)" : "translateY(20px) scale(1)",
          transition: "transform 300ms cubic-bezier(0.34, 1.56, 0.64, 1), opacity 200ms ease-out",
          transitionDelay: imageHovered ? "0ms" : "200ms",
          opacity: isVisible ? 1 : 0
        }} onMouseEnter={() => setImageHovered(true)} onMouseLeave={() => setImageHovered(false)}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1475502/img/image_9fqhg72m.jpg" alt="Professional Portrait" className="w-80 md:w-96 mx-auto h-auto rounded-lg shadow-soft object-cover" style={{
            borderRadius: "8px"
          }} />
          </div>

          {}
          <div className="flex flex-col gap-5">
            {}
            <div className="flex flex-col gap-2">
              <div className="flex flex-col gap-2">
                <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground leading-tight">
                  Who I Am
                </h2>
                <div className="w-24 h-0.5 bg-secondary" style={{
                backgroundColor: "hsl(170, 70%, 45%)"
              }} />
              </div>
              <p className="text-foreground/90 text-base leading-normal">Advertisers expect results. Sales teams need reliable execution. Internal teams depend on accurate data. I make sure all of those pieces work together.</p>
            </div>

            {}
            <div className="flex flex-col gap-2">
              <div className="flex flex-col gap-2">
                <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground leading-tight">
                  What I Do
                </h2>
                <div className="w-24 h-0.5 bg-secondary" style={{
                backgroundColor: "hsl(170, 70%, 45%)"
              }} />
              </div>
              <p className="text-foreground/90 text-base leading-normal">
                I specialize in the operational and analytical work that keeps advertisers satisfied and revenue performing as expected. From campaign implementation and troubleshooting to performance analysis and coordination with sales teams, I focus on making ad operations run smoothly and predictably.
              </p>
              <p className="text-foreground/90 text-base leading-normal">I also manage marketing tagging and conversion tracking for internal measurement, including ensuring tags function correctly within consent management platforms (CMPs). This helps maintain data integrity while supporting compliance and accurate reporting.</p>
            </div>

            {}
            <div ref={whyRef} className="flex flex-col gap-2" style={{
            opacity: whyVisible ? 1 : 0,
            transform: whyVisible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 200ms ease-out, transform 200ms ease-out"
          }}>
              <div className="flex flex-col gap-2">
                <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground leading-tight">
                  Why It Matters
                </h2>
                <div className="w-24 h-0.5 bg-secondary" style={{
                backgroundColor: "hsl(170, 70%, 45%)"
              }} />
              </div>
              <p className="text-foreground/90 text-base leading-normal">
               Whether working collaboratively or independently, I bring a steady, detail-oriented approach to complex systems so teams can trust the data, the delivery, and the results.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}